import React, { useEffect, useMemo } from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import { AppPages } from 'types/Enums';
import BackButton from './BackButton';

type RouteConfig = {
  path: `${AppPages}` | `${AppPages}/${string}`;
  title: string | ((params: Record<string, string>) => string);
};

type HeaderProps = {
  bottomNavPages: AppPages[];
  pageTitleMap: RouteConfig[];
};

const Header: React.FC<HeaderProps> = ({ bottomNavPages, pageTitleMap }) => {
  const location = useLocation();
  const pathname = location.pathname as AppPages;

  const BACK_BUTTON_PREFIXES = [
    '/settings/help_and_feedback',
    '/settings/privacy_policy',
    '/settings/terms_of_use',
    '/settings/about',
    '/settings/history',
    '/settings/blocked_list',
    '/settings/wallet',
    '/settings'
  ];
  const showBackButton = BACK_BUTTON_PREFIXES.some((p) => pathname.startsWith(p));

  const pageTitle = useMemo(() => {
    const matched = pageTitleMap.find((route) => matchPath(route.path, pathname));
    if (!matched) return 'App';

    const match = matchPath(matched.path, pathname);
    const params: Record<string, string> = {};
    if (match?.params) {
      Object.entries(match.params).forEach(([key, value]) => {
        params[key] = value ?? '';
      });
    }

    return typeof matched.title === 'function' ? matched.title(params) : matched.title;
  }, [pathname, pageTitleMap]);

  useEffect(() => {
    document.title = `${pageTitle} | MyApp`;
  }, [pageTitle]);

  return (
    <div className="sticky top-0 z-50 flex items-center px-4 pb-4 pt-[104px] justify-between bg-background-light dark:bg-background-dark">
      <div className="flex items-center" style={{ minWidth: 40 }}>
        <BackButton show={showBackButton} />
      </div>
      <div className="flex-1" />
    </div>
  );
};

export default Header;
